import React, { useState, useEffect } from "react";
import firebase from "@firebase/app";
import "@firebase/auth";
import BoxQrcodesFilesTable from "../components/Products/BoxQrcodesFilesTable";
import { getProductsBoxesFiles, addBoxesQrcodes } from "../services/ProductService";
import "react-datepicker/dist/react-datepicker.css";
import {Container,Col,Row,Button} from "react-bootstrap";
import { Input } from "reactstrap";
import {ConfirmProductsBoxModal} from "../components/Modals/ConfirmProductsBoxModal";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import "../assets/css/table.css"

function BoxQrcodesFilesListView() {
  const [productsBoxes, setProductsBoxes] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [productsLoading, setProductsLoading] = useState(false);

  const [filters, setFilters] = useState({
    name: '',
    new:false 
  });


  function onChange(user) {
    if (!user) {
      window.location.href = "/";
    }
    setLoading(false);
  }

  React.useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged(onChange);
    return () => unsubscribe();
  }, []);

  useEffect(async () => {
    if (!loading) {
      setProductsLoading(true);
      const productsBoxes = await getProductsBoxesFiles();
      if (!productsBoxes) {
        alert("Une erreur s'est produite");
        return;
      }
      setProductsBoxes(productsBoxes);
      setProductsLoading(false);
    }
  }, [loading]);

  if (loading || productsLoading) {
    return (
      <div style={{ flex: 1, textAlign: "center" }}>
        <Loader type="TailSpin" color="#00BFFF" height={100} width={100} />
      </div>
    );
  }
  if (!productsBoxes) {
    console.log("No productsBoxes");
    return null;
  }

  const handleSearchFilter = (filterType, value) => {
    let newFilter = {
      ...filters,
      [filterType]: value,
    };
    setFilters(newFilter);
  };

  const submitSearch = (name) => {
      let filteredProducts = [...productsBoxes];
      filteredProducts.forEach(box => {
        if (name.trim().length > 0) {
          box.hide = !box.fileName.toLowerCase().includes(name)
        } else {
          box.hide = false;
        }
      });
      setProductsBoxes(filteredProducts);
  };

  const handleCloseConfirmModal = () => setShowConfirmModal(false);

  const handleStockConfrimClick = (title) => {
    setShowConfirmModal(false);
    addBoxesQrcodes(productsBoxes, title);
  }

  return (
    <Container fluid>
      <ConfirmProductsBoxModal
        show={showConfirmModal}
        handleClose={handleCloseConfirmModal}
        handleClick={handleStockConfrimClick}
        productsBoxes={productsBoxes}
      ></ConfirmProductsBoxModal>
        <Row md="12" style={{ alignItems: "flex-end" }}>
          <Col md="9">
            <label htmlFor="name">Name</label>
            <Input value={filters.fileName} onChange={(e) => {
              handleSearchFilter('fileName', e.target.value)
              submitSearch(e.target.value.toLowerCase());
            }}/>
          </Col>
        </Row>
        <BoxQrcodesFilesTable
          productsBoxes={productsBoxes}
        />
    </Container>
  );
}

export default BoxQrcodesFilesListView;
